import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { frappePost } from '@/lib/frappe';

export const groupSessionKeys = {
  all: ['group-sessions'] as const,
  upcoming: (type?: string) => [...groupSessionKeys.all, 'upcoming', type] as const,
  mine: () => [...groupSessionKeys.all, 'mine'] as const,
};

export function useUpcomingGroupSessions(halaqahType?: string, page: number = 1, pageSize: number = 12) {
  return useQuery({
    queryKey: groupSessionKeys.upcoming(halaqahType),
    queryFn: () =>
      frappePost(
        'hudan_lms.hudan_lms.doctype.hudan_group_session.hudan_group_session.get_upcoming_group_sessions',
        {
          ...(halaqahType ? { halaqah_type: halaqahType } : {}),
          page,
          page_size: pageSize,
        }
      ),
  });
}

export function useMyGroupSessions() {
  return useQuery({
    queryKey: groupSessionKeys.mine(),
    queryFn: () =>
      frappePost('hudan_lms.hudan_lms.doctype.hudan_group_session.hudan_group_session.get_my_group_sessions'),
  });
}

export function useJoinGroupSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { session_name: string }) =>
      frappePost(
        'hudan_lms.hudan_lms.doctype.hudan_group_session.hudan_group_session.join_group_session',
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: groupSessionKeys.upcoming() });
      queryClient.invalidateQueries({ queryKey: groupSessionKeys.mine() });
    },
  });
}

export function useLeaveGroupSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { session_name: string }) =>
      frappePost(
        'hudan_lms.hudan_lms.doctype.hudan_group_session.hudan_group_session.leave_group_session',
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: groupSessionKeys.upcoming() });
      queryClient.invalidateQueries({ queryKey: groupSessionKeys.mine() });
    },
  });
}
